/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaypalResponse
 */
export interface PaypalResponse {
    /**
     * 
     * @type {string}
     * @memberof PaypalResponse
     */
    redirectUrl?: string;
}

/**
 * Check if a given object implements the PaypalResponse interface.
 */
export function instanceOfPaypalResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaypalResponseFromJSON(json: any): PaypalResponse {
    return PaypalResponseFromJSONTyped(json, false);
}

export function PaypalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaypalResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'redirectUrl': !exists(json, 'redirectUrl') ? undefined : json['redirectUrl'],
    };
}

export function PaypalResponseToJSON(value?: PaypalResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'redirectUrl': value.redirectUrl,
    };
}

